import axios from 'axios';

const API_BASE = '/api/feevoucher';

export const getStudentsByGrades = async (gradeIds) => {
  const response = await axios.get(`${API_BASE}/students`, { params: { gradeIds } });
  return response.data;
};

export const getVouchers = async (sessionId, month, gradeIds) => {
  const response = await axios.get(API_BASE, { params: { sessionId, month, gradeIds } });
  return response.data;
};

export const createVouchers = async (data) => {
  const response = await axios.post(API_BASE, data);
  return response.data;
};

// ── Weekly-per-term billing (only when the school has terms enabled) ──

export const getTermVouchers = async (termId, gradeIds) => {
  const response = await axios.get(`${API_BASE}/terms`, { params: { termId, gradeIds } });
  return response.data;
};

/** data: { termId, gradeIds, dueDate?, regenerate? } */
export const createTermVouchers = async (data) => {
  const response = await axios.post(`${API_BASE}/terms`, data);
  return response.data;
};

export const saveOrUpdateVouchers = async (data) => {
  const response = await axios.post(`${API_BASE}/save`, data);
  return response.data;
};
